<template>
  <div class="cart__footer">
    <div class="cart__footer-item">
      <span>Subtotal:</span>
      <span>{{ formatPrice(subTotal) }}</span>
    </div>
    <div class="cart__footer-item shipping">
      <span>Shipping:</span>
      <span v-if="!hasFreeShipping">{{ formatPrice(estimatedShipping) }}</span>
      <span v-else>Free</span>
    </div>
    <button class="cart__btn btn btn--primary btn--solid" type="submit">
      <svg class="icon icon--xs">
        <use href="#lock"></use>
      </svg>
      <span class="cart__btn-text">Checkout</span>
    </button>
    <ul class="cart__footer-icons">
      <li class="cart__footer-icon">
        <svg class="icon">
          <use href="#guarantee"></use>
        </svg>
        <span v-html="cartData.happiness_guarantee"></span>
      </li>
      <li class="cart__footer-icon">
        <svg class="icon">
          <use href="#shipping-small"></use>
        </svg>
        <span v-html="cartData.shipping_time"></span>
      </li>
    </ul>
  </div>
</template>

<script setup>
  import { computed, toRefs } from 'vue';

  const props = defineProps({
    cart: {
      type: Object,
      default: ({})
    },

    cartData: {
      type: Object,
      default: ({}) 
    },

    cartHasSubscriptionProducts: {
      type: Boolean,
      default: false
    },

    hasFreeShipping: {
      type: Boolean,
      default: false
    }
  })

  const { cart, cartData, cartHasSubscriptionProducts } = toRefs(props)

  const subTotal = computed(() => {
    return cart.value.total_price
  })

  const singleServingsOnly = computed(() => {
    return cart.value.items.every(item => item.variant_options[1] === '1');
  })

  const estimatedShipping = computed(() => {
    if (singleServingsOnly.value) {
      return cartData.value.shippingRates.single_servings.rate;
    } 

    if (cartHasSubscriptionProducts.value) {
      return subTotal.value < cartData.value.shippingRates.subscription.minimum ? cartData.value.shippingRates.subscription.rate : 0;
    }

    return subTotal.value < cartData.value.shippingRates.onetime.minimum ? cartData.value.shippingRates.onetime.rate : 0;
  });

  const formatPrice = (price) => {
    return window.formattedPrice(price/100)
  }
</script>